// types
import { Loan } from '../../../@types';

// i18n
import { useTranslation } from 'react-i18next';

// mui
import { Grid, Paper, Typography } from '@mui/material';

// ui
import { Empty } from '../../ui/Empty/Empty';
import { IconCircleLoan } from '../../ui/IconCircleLoan/IconCircleLoan';

// props
export interface CardLoansProps {
	isLoading?: boolean;
	loans: Loan[];
}

export const CardLoans = ({ isLoading = false, loans }: CardLoansProps) => {
	// hooks
	const { t } = useTranslation();

	let content = <Typography>{t('na')}</Typography>;

	if (isLoading) {
		content = <Empty hasContent={false} hasTitle={false} isLoading={true} position="absolute" />;
	} else if (loans.length) {
		content = (
			<Grid container spacing={2}>
				{loans.map((loan, i) => {
					return (
						<Grid item key={`loan-${loan.id}-${i}`} xs={12} lg={loans.length > 2 ? 6 : 12}>
							<Grid alignItems="center" container spacing={1}>
								<Grid item>
									<IconCircleLoan loan={loan} size="sm" />
								</Grid>
								<Grid item>
									<Typography fontWeight={600}>{loan.code}</Typography>
								</Grid>
							</Grid>
						</Grid>
					);
				})}
			</Grid>
		);
	}

	return (
		<Paper
			sx={(theme) => {
				return {
					position: 'relative',
					padding: theme.spacing(2),
					height: '100%',
				};
			}}>
			<Grid container spacing={2}>
				<Grid item xs={12}>
					<Typography variant="h3">{t('financingSources')}</Typography>
				</Grid>
				<Grid item xs={12}>
					{content}
				</Grid>
			</Grid>
		</Paper>
	);
};
